import { render, staticRenderFns } from "./uploadFile2.vue?vue&type=template&id=fae0e16c&"
import script from "./uploadFile2.vue?vue&type=script&lang=js&"
export * from "./uploadFile2.vue?vue&type=script&lang=js&"
import style0 from "./uploadFile2.vue?vue&type=style&index=0&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports